<h1 class="page-title" *ngIf="!loading && collection">
  {{ collection.public_title || collection.title }}
</h1>

<app-loading-spinner *ngIf="loading"></app-loading-spinner>

<div class="container" *ngIf="!loading">
  <div class="row">
    <div class="col">
      <google-map [options]="mapOptions" width="100%">
        <map-marker *ngFor="let marker of markers"
                    [position]="{ lat: marker.lat, lng: marker.lng }"
                    [options]="marker.markerOptions"
                    [clickable]="true"
                    [icon]="marker.selected ? selectedIconUrl : defaultIconUrl"></map-marker>
      </google-map>
    </div>
  </div>

  <mat-tab-group *ngIf="!loading && collection && collectionAvailableData">
    <mat-tab label="Dataset Data">
      <app-product-page-data
        [collectionId]="collectionId"
        [collection]="collection"
        [allStations]="allStations"
        [collectionAvailableData]="collectionAvailableData"
        [variableKeys]="variableKeys"
        [datasetStations]="datasetStations"
        [publicNamesMap]="publicNamesMap"
        (sendActiveVariable)="updateActiveStation($event)"></app-product-page-data>
    </mat-tab>
    <mat-tab label="Dataset Charts">
      <!--
        #24 — the charts are created only once chart eligibility is resolved and the stored
        selection pruned, so <app-graph> cannot replay a disabled or unavailable variable.
      -->
      <app-loading-spinner *ngIf="!chartEligibilityResolved"></app-loading-spinner>
      <app-product-page-charts
        *ngIf="chartEligibilityResolved"
        [collection]="collection"
        [variableKeys]="chartEnabledKeys">
      </app-product-page-charts>
    </mat-tab>
  </mat-tab-group>

  <div *ngIf="!collection || !collectionAvailableData">No Available Data</div>
</div>
